/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';

import AppDownloadImageLinks from 'components/AppDownloadImageLinks.jsx';
import Footer from 'components/Footer.jsx';
import MessagesHeader from 'messages/components/MessagesHeader.jsx';
import ModalsContainer from 'components/ModalsContainer.jsx';

import './styles/Messages.scss';

// get this into Webpack build so it's in our CDN for BranchBanner.ejs
require('assets/images/app-download-icon-72.png');

class Messages extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
  };

  static childContextTypes = {
    routes: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
  };

  // TODO remove
  getChildContext() {
    return {
      routes: this.props.routes,
      location: this.props.location,
      params: this.props.params,
    };
  }

  render() {
    return (
      <div>
        <ModalsContainer />
        <div className="Messages">
          <div className="Messages-header">
            <MessagesHeader />
          </div>
          <div className="Messages-content">{this.props.children}</div>
          <AppDownloadImageLinks />
          <Footer />
        </div>
      </div>
    );
  }
}

export default Messages;
